import {
  LOYALTY_TIER_REQUESTING,
  LIST_LOYALTY_TIERS_SUCCESS,
  RESET_LOYALTY_TIER_QUERY,
  RESET_LOYALTY_TIER_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  query: null,
  recordCount: null,
  isFetching: false,
  currentOrderId: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_LOYALTY_TIER_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case RESET_LOYALTY_TIER_QUERY: {
      return {
        ...state,
        query: null,
        recordCount: null
      };
    }
    case LOYALTY_TIER_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_LOYALTY_TIERS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        data,
        query,
        isFetching: false,
        recordCount: action.payload.length
      };
    }
    default:
      return state;
  }
};

export default reducer;
